const reducer = (state, action) => {
  return {
    ...state,
    giftCardToken: action.payload,
  };
};

export default reducer;
